// Small helper for firing a fetch that the backend answers with turbo_stream
// actions, rendered via Turbo.renderStreamMessage. Use this (rather than a
// frame-targeted form/link) when the response needs to do more than replace one
// frame — e.g. fill a modal AND open it, or update a list AND close a modal.

class TurboResponse {
  constructor(ok, status, error = null) {
    this.ok = ok
    this.status = status
    this.error = error
    if (error) { console.error("[TurboFetch]", error) }
  }

  onSuccess(fn) {
    if (this.ok) { fn(this) }
    return this
  }

  onFailure(fn) {
    if (!this.ok && !this.error) { fn(this) }
    return this
  }

  onError(fn) {
    if (this.error) { fn(this.error) }
    return this
  }
}

function csrfToken() {
  return document.querySelector("meta[name=\"csrf-token\"]")?.content
}

async function renderAndWrap(response) {
  Turbo.renderStreamMessage(await response.text())
  return new TurboResponse(response.ok, response.status)
}

const TurboFetch = {
  async get(url) {
    try {
      const response = await fetch(url, {
        headers: { "Accept": "text/vnd.turbo-stream.html" },
      })
      return renderAndWrap(response)
    } catch (error) {
      return new TurboResponse(false, null, error)
    }
  },

  async post(url, body) {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": csrfToken(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
      return renderAndWrap(response)
    } catch (error) {
      return new TurboResponse(false, null, error)
    }
  },
}

export default TurboFetch
